export default __webpack_public_path__ + "static/media/bryst-zoomed.2dbac51f.svg";